import { env } from './env';

/**
 * App push registration stub.
 * Backend still needs FCM/APNs device-token binding APIs.
 */

function registerPush() {
    if (!env.is_native()) {
        return Promise.resolve(null);
    }
    const cap = env.getCapacitor();
    const PushNotifications = cap && cap.Plugins && cap.Plugins.PushNotifications;
    if (!PushNotifications) {
        console.warn('[push] PushNotifications plugin not available');
        return Promise.resolve(null);
    }

    return PushNotifications.requestPermissions().then((perm) => {
        if (perm.receive !== 'granted') {
            return null;
        }
        return PushNotifications.register().then(() => {
            return new Promise((resolve) => {
                PushNotifications.addListener('registration', (token) => {
                    try {
                        localStorage.setItem('push_device_token', token.value);
                        localStorage.setItem('push_platform', env.platform_name());
                    } catch (e) {
                        // ignore storage errors
                    }
                    // TODO: POST token to microservice when device-token API is ready
                    console.log('[push] device token registered');
                    resolve(token.value);
                });
                PushNotifications.addListener('registrationError', (err) => {
                    console.error('[push] registration error', err);
                    resolve(null);
                });
            });
        });
    }).catch((err) => {
        console.error('[push] init failed', err);
        return null;
    });
}

export const push = {
    registerPush
};
